import { Injectable } from '@angular/core';
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

@Injectable({
  providedIn: 'root',
})
export class UtcToLocalService {

  utcTimestampToDayjs(
    utcTimestamp: number,
  ): Dayjs {
    const timeZone: string = dayjs.tz.guess();
    const dayjsObj: Dayjs = dayjs.utc(utcTimestamp).tz(timeZone);
    return dayjsObj;
  }
}
